/**
 * JIT Reason to Partner JavaScript
 * Handles animations and interactions for the franchise reason section
 */

document.addEventListener('DOMContentLoaded', function() {
  initPartnerReasonAnimations();
  initPartnerReasonInteractions();
});

/**
 * Initialize animations for partner reason cards
 */
function initPartnerReasonAnimations() {
  // Check if Intersection Observer is supported
  if ('IntersectionObserver' in window) {
    const observerOptions = {
      threshold: 0.2,
      rootMargin: '0px 0px -50px 0px'
    };
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          
          // Trigger counter animation if the element has numbers
          const numberElement = entry.target.querySelector('.text-cities-stores');
          if (numberElement && numberElement.textContent.match(/\d+/)) {
            animateNumbers(numberElement);
          }
          
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    // Observe all partner reason cards
    const reasonCards = document.querySelectorAll('.grid-item-content');
    reasonCards.forEach((card, index) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(30px)';
      card.style.transition = `opacity 0.6s ease ${index * 0.1}s, transform 0.6s ease ${index * 0.1}s`;
      observer.observe(card);
    });
  }
}

/**
 * Animate numbers in text content
 * @param {Element} element - Element containing numbers to animate
 */
function animateNumbers(element) {
  const text = element.textContent;
  const numbers = text.match(/\d+/g);
  
  if (numbers) {
    numbers.forEach(number => {
      const targetNumber = parseInt(number);
      let currentNumber = 0;
      const increment = targetNumber / 30; // 30 steps
      const duration = 1500; // 1.5 seconds
      const stepTime = duration / 30;
      
      const timer = setInterval(() => {
        currentNumber += increment;
        
        if (currentNumber >= targetNumber) {
          currentNumber = targetNumber;
          clearInterval(timer);
        }
        
        const newText = text.replace(number, Math.floor(currentNumber));
        element.textContent = newText;
      }, stepTime);
    });
  }
}

/**
 * Add smooth scrolling for anchor links within the section
 */
function initSmoothScrolling() {
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  
  anchorLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      
      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    });
  });
}

// Initialize smooth scrolling
initSmoothScrolling();

// Export functions for potential external use
window.JITPartnerReason = {
  initPartnerReasonAnimations,
  initPartnerReasonInteractions,
  animateNumbers
};
